import { constantsRegistry } from './tableConstantsFactory';

// Register the constants for form annotation actions
const constants = constantsRegistry('annotation');

// Add our custom constants
constants.CHANGE = 'ANNOTATION_CHANGE';
constants.BATCH_CHANGE = 'ANNOTATION_BATCH_CHANGE';
constants.CLEAR_EDITOR_STATE = 'ANNOTATION_CLEAR_EDITOR_STATE';
constants.LOAD = 'ANNOTATION_LOAD';
constants.LOAD_FAILURE = 'ANNOTATION_LOAD_FAILURE';
constants.LOAD_PERSISTED_STATE = 'ANNOTATION_LOAD_PERSISTED_STATE';
constants.LOAD_SUCCESS = 'ANNOTATION_LOAD_SUCCESS';
constants.PERSIST_EDITOR_STATE = 'ANNOTATION_PERSIST_EDITOR_STATE';
constants.SET_EDITOR_STATE = 'ANNOTATION_SET_EDITOR_STATE';
export default constants;